"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DndRow = exports.useRowDnd = void 0;
const React = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const utilities_1 = require("./utilities");
function IsUseRowDndTableInstance(instance) {
    return typeof instance.getRowDndProps === "function";
}
/** Allows rows to be dragged and dropped onto each other. The DndRow component must be used to render each row. See UseRowDndOptions for required table options.
 * @description This plugin interoperates with UseRowSelect such that:
 * - if the drags starts on a selected row, any other selected rows are also dragged
 * - if the drags starts on an unselected row, that row becomes the only selected row and is the only row dragged
 * - after a successful drop, the row selection is cleared
 */
function useRowDnd(hooks) {
    hooks.prepareRow.push((row, { instance }) => {
        if (!IsUseRowDndTableInstance(instance)) {
            throw new Error("Missing required option(s) for useRowDrag plugin");
        }
        const rowDndProps = instance.getRowDndProps(row, instance);
        Object.assign(row, rowDndProps);
    });
}
exports.useRowDnd = useRowDnd;
function IsUseRowDndRow(row) {
    return typeof row.isDraggable !== "undefined";
}
function DndRow({ row, instance }) {
    const { cells, getRowProps } = row;
    const rowDndOptions = IsUseRowDndRow(row)
        ? row
        : { isDraggable: false, isDropTarget: false };
    const dragItemType = {
        type: rowDndOptions.isDraggable ? rowDndOptions.isDraggable.type : "__noDrag"
    };
    const [_, drag] = react_dnd_1.useDrag({
        item: dragItemType,
        collect: monitor => ({
            isDragging: !!monitor.isDragging(),
        }),
        begin: () => {
            // Where rows are selectable, drag all selected rows
            if (utilities_1.IsRowSelectTableInstance(instance)) {
                // If the current row isn't selected, it now becomes the only selected row
                if (utilities_1.IsSelectableRow(row) && !row.isSelected) {
                    instance.toggleAllRowsSelected(false);
                    row.toggleRowSelected(true);
                }
                return Object.assign(Object.assign({}, dragItemType), { rows: instance.selectedFlatRows });
            }
            else {
                // Just drag the current row
                return Object.assign(Object.assign({}, dragItemType), { rows: [row] });
            }
        }
    });
    const [, drop] = react_dnd_1.useDrop({
        canDrop: () => !!rowDndOptions.isDropTarget,
        accept: rowDndOptions.isDropTarget ? rowDndOptions.isDropTarget.acceptType : "__noDrop",
        drop: dropped => {
            if (rowDndOptions.isDropTarget) {
                rowDndOptions.isDropTarget.onDrop(dropped.rows, row);
                // Deselect rows after successful drop
                if (utilities_1.IsRowSelectTableInstance(instance)) {
                    instance.toggleAllRowsSelected(false);
                }
            }
        }
    });
    // Only engage drag if item is draggable
    // This avoids issues with selecting text in Firefox https://github.com/react-dnd/react-dnd/issues/178
    const setupDragAndDrop = (ref) => {
        if (rowDndOptions.isDraggable) {
            drag(ref);
        }
        drop(ref);
    };
    return React.createElement("div", Object.assign({}, getRowProps(), { ref: setupDragAndDrop }), // Loop over the rows cells
    cells.map(cell => {
        // Apply the cell props
        return (React.createElement("div", Object.assign({}, cell.getCellProps()), // Render the cell contents
        cell.render('Cell')));
    }));
}
exports.DndRow = DndRow;
//# sourceMappingURL=row-dnd.js.map